import { FC } from "react";

import { useTheme } from "@mui/material";

import { STEP_TO_ELEMENT_ID } from "@/features/LiveFormEditor/AnimatePreview/Arrow/ArrowContext";
import { FormExpandableText, FormExpandableTextProps } from "@/forms-design-system/FormExpandableText";
import { useSanitizeHtmlString } from "@/helpers/html";
import { useMediaQuery } from "@/hooks/useMediaQuery";
type ThemedFormDescriptionProps = Omit<
  FormExpandableTextProps,
  "children" | "maxHeight" | "gradientOverlayHeight" | "gradientOverlayColor"
> & {
  description: string;
};

export const ThemedFormDescription: FC<ThemedFormDescriptionProps> = ({ description, ...rest }) => {
  const theme = useTheme();
  const { isSmallScreen } = useMediaQuery();
  const sanitizedDescription = useSanitizeHtmlString(description);

  return (
    <FormExpandableText
      {...rest}
      id={STEP_TO_ELEMENT_ID["description"]} // Required for scroll preview on description text
      data-test="form-v2-description"
      maxHeight={{ xs: "60px", md: "80px" }}
      gradientOverlayHeight="20px"
      gradientOverlayColor={
        isSmallScreen ? theme.palette.background.default : theme.palette.formsComponents.block.cardBackgroundColor
      }
      amplitudeEventType="form"
    >
      {sanitizedDescription}
    </FormExpandableText>
  );
};
